import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registered only so a phone will offer to install the site. The worker itself
// caches nothing — see public/sw.js for why that's deliberate.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Unsupported or blocked. The site works exactly the same either way.
    });
  });
}
